<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
    <router-outlet></router-outlet>
</div>

<app-notification></app-notification>
